import { PRODUCT_GROUP } from 'src/pages/patrimony/Patrimony.const'
import { PRODUCT_COLORS } from 'src/utils/getColor.const'

export const PRODUCT_GROUP_OF_LOAN_REPAID_GRAPH = {
  [PRODUCT_GROUP.immob]: true,
}

export const OVERVIEW_ICON = {
  [PRODUCT_GROUP.immob]: 'monochrome/overview.svg',
}

export const ENTRY_TYPE = {
  liability: 'liability',
  asset: 'asset',
} as const

export const OVERVIEW_COLOR = {
  [PRODUCT_GROUP.immob]: PRODUCT_COLORS.lightGreen,
}

export const FREQUENCY = {
  single: 1,
  monthly: 12,
  quarterly: 3,
  biannually: 2,
  yearly: 1,
}
